import { useMemo, useState } from 'react'
import { getPeriodoMesAtual } from '../../../../services/util/date.service'
import InsumoHttp from '../../../../services/api/https/insumos/insumo.http'

export const ACTION = {
  IDLE: 'idle',
  INITIAL_FETCH: 'Obtendo as informações Iniciais. . . ',
  GET_PAINEL_DATA: 'Carregando os dados do Painel',
}

const { dataInicial, dataFinal } = getPeriodoMesAtual()

const INIT_STATE = {
  errorMessage: null,
  action: ACTION.IDLE,
  pInicial: dataInicial,
  pFinal: dataFinal,
  insumos: [],
  insumoSelecionado: '',
  qteEntrada: '-',
  qteSaida: '-',
  qteDisponivel: '-',
  qtePorCx: '-',
  qtePorTon: '-',
  unidadeMovimentacao: '',
  rankingConsumoInsumo: [],
}

export default function usePainelInsumo() {
  const [state, setState] = useState({ ...INIT_STATE })

  const localDispatch = useMemo(() => {
    return {
      // Actions
      setAction(action) {
        setState(prevState => ({ ...prevState, action }))
      },

      getPainelInsumoInitialInfo(selectedTp) {
        InsumoHttp.getPainelInsumoInitialInfo(selectedTp)
          .then(insumos => {
            setState(prevState => ({
              ...prevState,
              action: ACTION.IDLE,
              insumos,
              insumoSelecionado: '',
              qteEntrada: '-',
              qteSaida: '-',
              qteDisponivel: '-',
              qtePorCx: '-',
              qtePorTon: '-',
              unidadeMovimentacao: '',
              rankingConsumoInsumo: [],
            }))
          })
          .catch(e => {
            setState(prevState => ({ ...prevState, action: ACTION.IDLE, errorMessage: e }))
          })
      },

      getPainelInsumoData(pInicial, pFinal, insumoSelecionado, selectedTp) {
        if (insumoSelecionado === '') {
          setState(prevState => ({
            ...prevState,
            action: ACTION.IDLE,
            errorMessage: 'Selecione o Insumo',
          }))
        } else {
          InsumoHttp.getPainelInsumoData(pInicial, pFinal, insumoSelecionado.id, selectedTp)
            .then(resp => {
              const {
                qteEntrada,
                qteSaida,
                qteDisponivel,
                qtePorCx,
                qtePorTon,
                unidadeMovimentacao,
                rankingConsumoInsumo,
              } = resp
              setState(prevState => ({
                ...prevState,
                qteEntrada,
                qteSaida,
                qteDisponivel,
                qtePorCx,
                qtePorTon,
                unidadeMovimentacao,
                rankingConsumoInsumo,
                action: ACTION.IDLE,
              }))
            })
            .catch(e => {
              setState(prevState => ({ ...prevState, action: ACTION.IDLE, errorMessage: e }))
            })
        }
      },

      resetState() {
        setState(prevState => ({ ...prevState, action: ACTION.IDLE, errorMessage: null }))
      },

      // Events
      onInsumoChange(insumo) {
        setState(prevState => ({
          ...prevState,
          insumoSelecionado: insumo,
          action: ACTION.GET_PAINEL_DATA,
        }))
      },
      onBtnPeriodoClick(pInicial, pFinal) {
        setState(prevState => ({
          ...prevState,
          action: ACTION.GET_PAINEL_DATA,
          pInicial,
          pFinal,
        }))
      },
    }
  }, [])

  return { state, localDispatch }
}
